
(function () {
  'use strict';

// Defaults
  
  const DEFAULTS = {
    maxProducts: 8,
    fallbackCollection: 'all',
    showVendor: false,
    showRating: false,
    showComparePrice: true,
    enabled: true,
    heading: 'You May Also Like',
  };

  let swiperInstance    = null;
  let currentProductIds = null;  
  let isFetching        = false;
  let cfg               = null;
  let domObserver       = null;
  let cartObserver      = null;
  let isCartUpdating    = false;
  let lastProducts      = null;

//   INIT

function init() {
  const section = document.getElementById('cart-upsell-section');
  if (!section) return;

  cfg = readConfig(section);
  console.log('[CartUpsell] Config:', cfg);

  if (!cfg.enabled) {
    section.classList.add('cart-upsell--hidden');
    return;
  }

  // Add event listener for cart updates
  document.addEventListener('cart:updated', () => {
    console.log('[CartUpsell] Cart updated event received');
    currentProductIds = null;
    refresh(true);
  });

  hookCartDrawer();
  watchCartMutations();
  watchForShellReplacement();
  hookFetchInterceptor();
  hookCurrencyChange();

  if (document.querySelector('cart-drawer.active')) {
    refresh(false);
  }
}

  function readConfig(el) {
    const d = el.dataset;
    return {
      enabled:            d.enabled !== 'false',
      maxProducts:        parseInt(d.maxProducts, 10) || DEFAULTS.maxProducts,
      fallbackCollection: d.fallbackCollection        || DEFAULTS.fallbackCollection,
      showVendor:         d.showVendor  === 'true',
      showRating:         d.showRating  === 'true',
      showComparePrice:   d.showComparePrice !== 'false',
      heading:            d.heading || DEFAULTS.heading,
    };
  }

 
window.cartUpsellRestore = function(cartDrawer) {
  injectUpsellShell(cartDrawer);
  const section = document.getElementById('cart-upsell-section');
  if (!section) return;
  cfg = readConfig(section);
  hookCartDrawer();
  watchCartMutations();
  hookFetchInterceptor();
  hookCurrencyChange();
  currentProductIds = null;  
  refresh(true);
};

window.cartUpsellRefresh = function() {
  const shellMissing = !document.getElementById('cart-upsell-section');
  if (shellMissing) {
    currentProductIds = null;
  }
  refresh(false);
};

async function refresh(force) {
  if (isFetching) return;
  isFetching = true;

  try {
    const cart = await fetchCart();
    const { productIds } = extractCartData(cart);
    const idsString = productIds.sort().join(',');

    if (!force && idsString === currentProductIds) {
      console.log('[CartUpsell] Product IDs unchanged, skipping fetch');

      const swiperExists = document.querySelector('.cart-upsell__slider-wrap .swiper');
      if (!swiperExists && lastProducts && lastProducts.length) {
        console.log('[CartUpsell] Swiper missing but IDs same, rebuilding from cache');
        await renderSlider(lastProducts);
      }
      return;
    }

    currentProductIds = idsString;

    if (!cart.items.length) {
      console.log('[CartUpsell] Cart is empty');
      document.getElementById('cart-upsell-section')
        ?.classList.add('cart-upsell--hidden');
      return;
    }

    console.log('[CartUpsell] Refreshing recommendations');
    showSkeleton();
    const products = await getRecommendations(cart);
    console.log('[CartUpsell] Fetched products:', products.length);
    lastProducts = products; 
    await renderSlider(products);
  } catch (err) {
    console.warn('[CartUpsell]', err);
    hideSkeleton();
  } finally {
    isFetching = false;
  }
}

  function hookFetchInterceptor() {
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const url = args[0];
    if (url && url.includes('/cart/change')) {
      isCartUpdating = true;
      console.log('[CartUpsell] Cart update started (POST /cart/change)');
      
      // Listen for the response
      return originalFetch.apply(this, args).then(response => {
        setTimeout(() => {
          isCartUpdating = false;
          console.log('[CartUpsell] Cart update finished');
          
          // Dispatch custom event
          const event = new CustomEvent('cart:updated', { 
            detail: { url, method: 'change' } 
          });
          document.dispatchEvent(event);
        }, 300);
        return response;
      });
    }
    return originalFetch.apply(this, args);
  };
}

  
  function hookCurrencyChange() {
    document.addEventListener('currency_converter_initialized', () => {
      console.log('[CartUpsell] Currency converter detected, watching for changes');
    });

    // Watch for Shopify's currency change event
    document.addEventListener('shopify:currency_selected', () => {
      console.log('[CartUpsell] Currency changed, re-rendering');
      setTimeout(() => {
        destroySwiper();
        const section = document.getElementById('cart-upsell-section');
        if (!section) return;
        refresh(false);
      }, 100);
    });

    // watch for DOM changes in currency selector
    const currencySelector = document.querySelector('[data-currency-selector], .currency-selector, [id*="currency"]');
    if (currencySelector) {
      const obs = new MutationObserver(() => {
        console.log('[CartUpsell] Currency selector changed, re-rendering');
        destroySwiper();
        setTimeout(() => refresh(false), 100);
      });
      obs.observe(currencySelector, { attributes: true, subtree: true });
    }
  }


  function hookCartDrawer() {
    const tryHook = () => {
      const el = document.querySelector('cart-drawer');
      if (!el || el.__upsellDrawerHooked || typeof el.open !== 'function') return;
      const orig = el.open.bind(el);
      el.open = function (...a) {
        orig(...a);
        refresh(false);
      };
      el.__upsellDrawerHooked = true;
    };
    tryHook();
    setTimeout(tryHook, 400);
  }

 
 function watchCartMutations() {
  if (cartObserver) cartObserver.disconnect();

  const attach = () => {
    const el = document.querySelector('cart-drawer-items');
    if (!el) return;
    cartObserver = new MutationObserver(() => {
      if (isCartUpdating) return;
      clearTimeout(cartObserver._t);
      cartObserver._t = setTimeout(() => {
        if (!document.querySelector('.cart-upsell__slider-wrap .swiper')) {
          currentProductIds = null;
          refresh(true);
        }
      }, 300);
    });
    cartObserver.observe(el, { childList: true });
  };
  attach();
  setTimeout(attach, 500);
}

  
  function watchForShellReplacement() {
  if (domObserver) domObserver.disconnect();
  const cartDrawer = document.getElementById('CartDrawer');
  if (!cartDrawer) return;

  domObserver = new MutationObserver(() => {
    if (!document.getElementById('cart-upsell-section')) {
      console.log('[CartUpsell] Shell replaced at CartDrawer level, re-injecting');
      injectUpsellShell(cartDrawer);
      reinit();
    }
  });
  domObserver.observe(cartDrawer, { childList: true, subtree: false });
}

  function injectUpsellShell(cartDrawer) {
    const c   = window.cartUpsellConfig || {};
    const div = document.createElement('div');
    div.id        = 'cart-upsell-section';
    div.className = 'cart-upsell';
    Object.assign(div.dataset, {
      enabled:            String(c.enabled          ?? true),
      maxProducts:        String(c.maxProducts       ?? 8),
      fallbackCollection: String(c.fallbackCollection ?? 'all'),
      showVendor:         String(c.showVendor        ?? false),
      showRating:         String(c.showRating        ?? false),
      showComparePrice:   String(c.showComparePrice  ?? true),
      heading:            String(c.heading           ?? 'You May Also Like'),
    });
    const h = div.dataset.heading;
    div.innerHTML = `
      <h2 class="cart-upsell__heading">${escHtml(h)}</h2>
      <div class="cart-upsell__nav" aria-hidden="true">
        <button id="cart-upsell-prev" class="cart-upsell__btn" aria-label="Previous products">
          <svg viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
        </button>
        <button id="cart-upsell-next" class="cart-upsell__btn" aria-label="Next products">
          <svg viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
        </button>
      </div>
      <div class="cart-upsell__slider-wrap"></div>`;

    const widget = cartDrawer.querySelector('.cart__items-widget') || cartDrawer;
    widget.appendChild(div);
  }

  function reinit() {
    swiperInstance    = null;
    currentProductIds = null;
    cfg               = null;
    const section     = document.getElementById('cart-upsell-section');
    if (!section) return;
    cfg = readConfig(section);
    hookCartDrawer();
    watchCartMutations();
    watchForShellReplacement();
    hookFetchInterceptor();
    hookCurrencyChange();
    refresh(true);
  }

//  REFRESH PIPELINE

  async function refresh(force) {
    if (isFetching) return;
    isFetching = true;

    try {
      const cart = await fetchCart();
      const { productIds } = extractCartData(cart);
      const idsString = productIds.sort().join(',');

      if (!force && idsString === currentProductIds) {
        console.log('[CartUpsell] Product IDs unchanged, skipping fetch');
         return; 

      }

      currentProductIds = idsString;

      if (!cart.items.length) {
        console.log('[CartUpsell] Cart is empty');
        document.getElementById('cart-upsell-section')
          ?.classList.add('cart-upsell--hidden');
        return;
      }

      console.log('[CartUpsell] Refreshing recommendations');
      showSkeleton();
      const products = await getRecommendations(cart);
      console.log('[CartUpsell] Fetched products:', products.length);
      await renderSlider(products);
    } catch (err) {
      console.warn('[CartUpsell]', err);
      hideSkeleton();
    } finally {
      isFetching = false;
    }
  }

//   CART DATA

  async function fetchCart() {
    const res = await fetch('/cart.js', { cache: 'no-store' });
    if (!res.ok) throw new Error('Cart fetch failed');
    return res.json();
  }

  function extractCartData(cart) {
    return {
      productIds: [...new Set(cart.items.map(i => i.product_id))],
    };
  }

  /* ═══════════════════════════════════════════════════════════════
   * RECOMMENDATION ENGINE  ← v5: Strict 3-tier waterfall
   * Strict priority order:
   *   P1 Related (first priority)
   *     → if has any products: return only Related, stop
   *   P2 Complementary (only if Related empty)
   *     → if has any products: return only Complementary, stop
   *   P3 Fallback collection (last resort)
   *     → use theme settings, not hardcoded
   * ═══════════════════════════════════════════════════════════════ */
  async function getRecommendations(cart) {
    const { productIds } = extractCartData(cart);
    const max     = cfg.maxProducts;
    const exclude = new Set(productIds.map(String));

    console.log('[CartUpsell] Product IDs in cart:', productIds);
    console.log('[CartUpsell] Fallback Collection:', cfg.fallbackCollection);

    /* ── P1: Related (first priority) ──────────────────────── */
    console.log('[CartUpsell] Fetching P1 Related products...');
    if (productIds.length > 0) {
      const related = await fetchRelated(productIds[0], max);
      const filtered = related.filter(p => !exclude.has(String(p.id)));
      if (filtered.length > 0) {
        console.log('[CartUpsell] Source: P1 Related | Count:', filtered.length);
        return filtered.slice(0, max);
      }
      console.log('[CartUpsell] P1 Related returned 0 products');
    }

    /* ── P2: Complementary (only if Related empty) ────────── */
    console.log('[CartUpsell] Fetching P2 Complementary products...');
    if (productIds.length > 0) {
      const complementary = await fetchComplementary(productIds[0], max);
      const filtered = complementary.filter(p => !exclude.has(String(p.id)));
      if (filtered.length > 0) {
        console.log('[CartUpsell] Source: P2 Complementary | Count:', filtered.length);
        return filtered.slice(0, max);
      }
      console.log('[CartUpsell] P2 Complementary returned 0 products');
    }

    /* ── P3: Fallback collection (last resort, from theme settings) ──── */
    console.log('[CartUpsell] Fetching P3 Fallback collection...');
    const fallback = await fetchFallbackCollection(cfg.fallbackCollection, max);
    const filtered = fallback.filter(p => !exclude.has(String(p.id)));
    if (filtered.length > 0) {
      console.log('[CartUpsell] Source: P3 Fallback | Count:', filtered.length);
      return filtered.slice(0, max);
    }
    console.log('[CartUpsell] P3 Fallback returned 0 products');

    console.log('[CartUpsell] No products found from any source');
    return [];
  }

  /* ── Fetch helpers ─────────────────────────────────────────── */

  /** P1 — Search & Discovery complementary intent */
  async function fetchComplementary(productId, limit) {
    if (!productId) return [];
    try {
      const res = await fetch(
        `/recommendations/products.json?product_id=${productId}&limit=${limit}&intent=complementary`
      );
      if (!res.ok) return [];
      const { products = [] } = await res.json();
      return products.filter(p => p.available);
    } catch (err) {
      console.warn('[CartUpsell] fetchComplementary error:', err);
      return [];
    }
  }

  /** P2 — Search & Discovery related intent */
  async function fetchRelated(productId, limit) {
    if (!productId) return [];
    try {
      const res = await fetch(
        `/recommendations/products.json?product_id=${productId}&limit=${limit}&intent=related`
      );
      if (!res.ok) return [];
      const { products = [] } = await res.json();
      return products.filter(p => p.available);
    } catch (err) {
      console.warn('[CartUpsell] fetchRelated error:', err);
      return [];
    }
  }

  /** P3 — Best-selling products from fallback collection (theme settings) */
  async function fetchFallbackCollection(handle, limit) {
    if (!handle) {
      console.warn('[CartUpsell] Fallback collection handle is empty');
      return [];
    }
    try {
      console.log('[CartUpsell] Fetching from collection:', handle);
      const res = await fetch(
        `/collections/${handle}/products.json?limit=${limit}&sort_by=best-selling`
      );
      if (!res.ok) {
        console.warn('[CartUpsell] Fallback collection fetch failed:', res.status);
        return [];
      }
      const { products = [] } = await res.json();

      // FIX: Use variants to check availability, not top-level p.available
      const available = products.filter(product =>
        product.variants?.some(variant => variant.available)
      );
      console.log('[CartUpsell] Fallback collection: fetched', products.length, 'available:', available.length);
      return available;
    } catch (err) {
      console.warn('[CartUpsell] fetchFallbackCollection error:', err);
      return [];
    }
  }

//   RENDERING

  async function renderSlider(products) {
    const section = document.getElementById('cart-upsell-section');
    if (!section) return;

    destroySwiper();
    hideSkeleton();

    const wrapper = section.querySelector('.cart-upsell__slider-wrap');
    if (!wrapper) return;

    if (!products.length) {
      console.log('[CartUpsell] No products to render');
      section.classList.add('cart-upsell--hidden');
      return;
    }

    section.classList.remove('cart-upsell--hidden');
    wrapper.innerHTML = `<div class="swiper"><div class="swiper-wrapper">${
      products.map(buildProductCard).join('')
    }</div></div>`;

    await waitForSwiper();

    if (window.Swiper) {
      swiperInstance = new window.Swiper(wrapper.querySelector('.swiper'), {
        slidesPerView: 2,
        spaceBetween: 12,
        grabCursor: true,
        navigation: {
          nextEl: document.getElementById('cart-upsell-next'),
          prevEl: document.getElementById('cart-upsell-prev'),
        },
        breakpoints: {
          768:  { slidesPerView: 2 },
          1200: { slidesPerView: 2 },
        },
        a11y: {
          prevSlideMessage: 'Previous product',
          nextSlideMessage: 'Next product',
        },
      });
    }

    section.querySelectorAll('.cart-upsell-card__add').forEach(btn =>
      btn.addEventListener('click', handleQuickAdd)
    );
  }

  function waitForSwiper(maxWait = 4000) {
    if (window.Swiper) return Promise.resolve();
    return new Promise(resolve => {
      const t0 = Date.now();
      (function check() {
        if (window.Swiper || Date.now() - t0 > maxWait) return resolve();
        setTimeout(check, 80);
      })();
    });
  }

  function buildProductCard(product) {
    const variant = product.variants?.[0] || {};
    const price   = formatMoney(variant.price);
    const compare = cfg.showComparePrice && variant.compare_at_price > variant.price
                      ? formatMoney(variant.compare_at_price) : null;

    console.log(`[CartUpsell] Product: ${product.title} | Price: ${price} | Compare: ${compare}`);

    let rawImg = product.featured_image || product.images?.[0] || '';
    if (rawImg && typeof rawImg === 'object') rawImg = rawImg.src || '';
    const sep   = rawImg.includes('?') ? '&' : '?';
    const image = rawImg
      ? rawImg.replace(/[?&]width=\d+/, '') + sep + 'width=400'
      : 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-product-1_large.png';

    const available   = variant.available !== false;
    const saleCls     = compare ? ' cart-upsell-card__price--sale' : '';
    const vendorHtml  = cfg.showVendor && product.vendor
                          ? `<p class="cart-upsell-card__vendor">${escHtml(product.vendor)}</p>` : '';
    const compareHtml = compare
                          ? `<s class="cart-upsell-card__price--compare">${compare}</s>` : '';
    const ratingHtml  = cfg.showRating && product.metafields?.reviews?.rating
                          ? buildRatingHtml(product.metafields.reviews.rating) : '';

    return `
      <div class="swiper-slide">
        <div class="cart-upsell-card">
          <a href="/products/${escHtml(product.handle)}" class="cart-upsell-card__image-wrap" tabindex="-1" aria-hidden="true">
            <img class="cart-upsell-card__image" src="${escAttr(image)}" alt="${escAttr(product.title)}" width="400" height="400" loading="lazy">
          </a>
          <div class="cart-upsell-card__body">
            ${vendorHtml}
            <a href="/products/${escHtml(product.handle)}" class="cart-upsell-card__title">${escHtml(product.title)}</a>
            ${ratingHtml}
            <div class="cart-upsell-card__price-wrap">
              <span class="s cart-upsell-card__price${saleCls}">${price}</span>
              ${compareHtml}
            </div>
            <button class="cart-upsell-card__add"
              data-variant-id="${variant.id}"
              data-product-id="${product.id}"
              ${!available ? 'disabled' : ''}
              aria-label="Add ${escAttr(product.title)} to cart">
              ${available ? 'Add to cart' : 'Sold out'}
            </button>
          </div>
        </div>
      </div>`;
  }

  function buildRatingHtml(r) {
    const val = parseFloat(r.value) || 0;
    const full = Math.round(val);
    return `<div class="cart-upsell-card__rating">
      <span class="cart-upsell-card__stars" aria-hidden="true">${'★'.repeat(full)}${'☆'.repeat(5 - full)}</span>
      <span>(${r.count || 0})</span></div>`;
  }

//   QUICK-ADD

  async function handleQuickAdd(e) {
  const btn = e.currentTarget;
  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.disabled = true;
  btn.classList.add('cart-upsell-card__add--loading');
  btn.textContent = 'Adding…';

  try {
    // Add the item to cart
    const addRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });
    
    if (!addRes.ok) throw new Error('Add failed');
    
    const cartData = await addRes.json();
    console.log('[CartUpsell] Product added successfully', cartData);

    // Request the updated cart drawer sections
    const sectionsUrl = `${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`;
    const sectionsRes = await fetch(sectionsUrl, { cache: 'no-store' });
    
    if (sectionsRes.ok) {
      const sections = await sectionsRes.json();
      
      // Update cart drawer content
      if (sections['cart-drawer']) {
        const cartDrawerElement = document.getElementById('CartDrawer');
        if (cartDrawerElement) {
          // Parse the HTML string
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = sections['cart-drawer'];
          const newDrawerContent = tempDiv.querySelector('.drawer__inner');
          
          if (newDrawerContent) {
            const currentDrawerInner = cartDrawerElement.querySelector('.drawer__inner');
            if (currentDrawerInner) {
              // Replace the drawer inner content
              currentDrawerInner.innerHTML = newDrawerContent.innerHTML;
              
              // Also copy any data attributes or classes
              if (newDrawerContent.className) {
                currentDrawerInner.className = newDrawerContent.className;
              }
            }
          }
        }
      }
      
      // Update cart icon bubble (cart count)
      if (sections['cart-icon-bubble']) {
        const bubbleElement = document.getElementById('cart-icon-bubble');
        if (bubbleElement) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = sections['cart-icon-bubble'];
          const newBubble = tempDiv.querySelector('.shopify-section');
          if (newBubble) {
            bubbleElement.innerHTML = newBubble.innerHTML;
          }
        }
      }
      
      // Dispatch a custom event that Shopify might listen for
      document.dispatchEvent(new CustomEvent('cart:updated', { 
        detail: { cart: cartData } 
      }));
      
      // Also try to trigger Shopify's built-in cart update event
      if (window.Shopify && window.Shopify.onCartUpdate) {
        window.Shopify.onCartUpdate(cartData);
      }
    }

    // Wait a bit for the DOM to update
    await new Promise(resolve => setTimeout(resolve, 200));
    
    // Refresh the upsell section (to exclude the newly added product)
    currentProductIds = null;
    await refresh(true);

    // Visual feedback
    btn.textContent = 'Added ✓';

    setTimeout(() => {
      btn.disabled = false;
      btn.classList.remove('cart-upsell-card__add--loading');
      btn.textContent = 'Add to cart';
      btn.style.background = '';
      btn.style.color = '';
      btn.style.borderColor = '';
    }, 2200);

  } catch (err) {
    console.warn('[CartUpsell] Quick-add error:', err);
    btn.disabled = false;
    btn.classList.remove('cart-upsell-card__add--loading');
    btn.textContent = 'Try again';
    
    // Show error feedback
    setTimeout(() => {
      if (btn.textContent === 'Try again') {
        btn.textContent = 'Add to cart';
      }
    }, 2000);
  }
}

// Skeleton
 
  function showSkeleton() {
    const section = document.getElementById('cart-upsell-section');
    if (!section) return;
    section.classList.remove('cart-upsell--hidden');
    const wrap = section.querySelector('.cart-upsell__slider-wrap');
    if (!wrap) return;
    destroySwiper();
    wrap.innerHTML = `
      <div class="cart-upsell-skeleton" aria-hidden="true">
        <div class="cart-upsell-skeleton__item"><div class="cart-upsell-skeleton__img"></div><div class="cart-upsell-skeleton__line"></div><div class="cart-upsell-skeleton__line cart-upsell-skeleton__line--short"></div></div>
        <div class="cart-upsell-skeleton__item"><div class="cart-upsell-skeleton__img"></div><div class="cart-upsell-skeleton__line"></div><div class="cart-upsell-skeleton__line cart-upsell-skeleton__line--short"></div></div>
      </div>`;
  }

  function hideSkeleton() {
    document.getElementById('cart-upsell-section')
      ?.querySelector('.cart-upsell-skeleton')?.remove();
  }

//  SWIPER

  function destroySwiper() {
    if (swiperInstance) {
      try { swiperInstance.destroy(true, true); } catch {}
      swiperInstance = null;
    }
  }

//   UTILITIES

 function formatMoney(cents) {
  if (cents == null) return '';

  const moneyFormat =
    window.DT_THEME?.moneyFormat ||
    window.theme?.moneyFormat ||
    '${{amount}}';

  if (window.Shopify?.formatMoney) {
    return window.Shopify.formatMoney(cents, moneyFormat);
  }
console.log('DT_THEME.moneyFormat', window.DT_THEME?.moneyFormat);
  return (cents / 100).toFixed(2);
}
  function escHtml(s) {
    return String(s ?? '')
      .replace(/&/g,'&amp;').replace(/</g,'&lt;')
      .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
  function escAttr(s) { return String(s ?? '').replace(/"/g,'&quot;'); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();